<template>
  <div v-show="isShow" class="tool">
    <div class="toolbar">
      <div class="emoji" @click="showEmoji=!showEmoji">
        <span class="emoji_icon"></span>
        <transition name="showbox">
          <div class="emojiBox" v-show="showEmoji">
            <li v-for="item in emojis">
              <div @click="emojiSelect(item)">{{item}}</div>
            </li>
          </div>
        </transition>
      </div>
      <div class="file_upload">
        <div class="upload_icon" @click="fileSelect"></div>
        <input type="file" name="fileToUpload" ref="fileToUpload" @change="fileSelected">
      </div>
    </div>
    <div class="editArea">
      <textarea ref="text" placeholder="" v-model="content" @keyup="onKeyup"></textarea>
    </div>
    <div class="action">
      <el-button type="primary" :show-loading="false" @click.native.prevent="send">发送</el-button>
    </div>
  </div>
</template>

<script>
  import {mapState,mapGetters,mapActions} from 'vuex';
  import {socket} from '@/common/im/socket'
  import {emojiList} from '@/common/im/util'
  import SparkMD5 from 'spark-md5'
  export default {
    data () {
      return {
        content: '',
        showEmoji: false,
        emojis: emojiList
      }
    },
    methods: {
    	emojiSelect(item) {
    		this.content += item;
        this.$refs.text.focus();
      },
      fileSelect() {
        this.$refs.fileToUpload.click();
      },
      fileSelected() {

        if (!this.checkAuthority()) {
          return;
        }

      	let dom = this.$refs.fileToUpload;

        if (dom.files.length !== 0) {
        	let file = dom.files[0];

          if((file.type).indexOf("image/")===-1) {
            this.$message.error('请选择图片');
            dom.value = "";
            return;
          }
          if (file.size/1000/1000 > 2) {
            this.$message.error('请选择大小不超过2MB的图片');
            dom.value = "";
            return;
          }

          this.getFileMd5(file,
            function (data) {
              let src = window.URL.createObjectURL(file);
              let message = this.messageImage(src,data);

              let reader = new FileReader();
              reader.readAsArrayBuffer(file);
              reader.onload = function(event) {
                let fileData = event.target.result;
                socket.sendMessage(message,fileData);
              };
              this.sendChatMessage(message);

              dom.value = "";
            }
          );

        }
      },
      onKeyup (e) {
        if (e.keyCode === 13 && this.content.length) {
          this.send();
        }
      },
      send () {
    		if (!this.checkAuthority()) {
          return;
        }
      	if (this.content.length) {
      		let message = this.messageText();
      		socket.sendMessage(message,null);
          this.sendChatMessage(message);
          this.content = ''
        }
      },
      messageText () {
        let content = {
          text: this.content
        };
        return {
        	msg_type: 'Text',
          msg_content: content,
          msg_id: Math.random()*10000,
          conversation_id: this.conversationID,
          chat_type: 'Single',
          receiver_uid: this.conversation.uid,
          sender_uid: this.userID,
          sendtime: new Date().getTime(),
          timestamp: new Date().getTime()
        }
      },
      messageImage (src,name) {
        let content = {
          fileName: name+'.jpg',
          preview: src
        };
        return {
          msg_type: 'Image',
          msg_content: content,
          msg_id: Math.random()*10000,
          conversation_id: this.conversationID,
          chat_type: 'Single',
          receiver_uid: this.conversation.uid,
          sender_uid: this.userID,
          sendtime: new Date().getTime(),
          timestamp: new Date().getTime()
        }
      },
      checkAuthority () {
    		switch (this.status) {
          case 0:
          {
            this.updateStatus();
          }
            break;
          case 1:
          {
            let count = this.messages.length;
            if (count + 1 > this.conversation.limit_num) {
              this.$message.error('发送消息已达上限,请等待对方回复');
            	return false;
            }
          }
            break;
          case 2:
          {
            this.updateStatus();
          }
            break;
          case 3:
          {

          }
            break;
          default:
          	break;
        }
    		return true;
      },
      updateStatus () {

        let parameters = {};
        parameters.isCreator = this.conversation.isCreator ? 1 : 0;
        parameters.conversation_id = this.conversation.conversation_id;
        parameters.status = 1;

    		this.updateConversationStatus(parameters);

        let param = {};
        param.uid = this.conversation.uid;
        param.conversation_id = this.conversation.conversation_id;
        param.status = 1;

        socket.updateStatus(param);
      },
      getFileMd5 (blob,callback) {
        let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice,
            file = blob,
            chunkSize = 2097152,                             // Read in chunks of 2MB
            chunks = Math.ceil(file.size / chunkSize),
            currentChunk = 0,
            spark = new SparkMD5.ArrayBuffer(),
            fileReader = new FileReader();

        fileReader.onload = function (e) {
          spark.append(e.target.result);                   // Append array buffer
          currentChunk++;

          if (currentChunk < chunks) {
            loadNext();
          } else {
            callback(spark.end());
          }
        };

        fileReader.onerror = function () {
          console.warn('oops, something went wrong.');
        };

        function loadNext() {
          let start = currentChunk * chunkSize,
              end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize;
          fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
        }

        loadNext();
      },
      ...mapActions([
        'sendChatMessage',
        'updateConversationStatus'
      ])
    },
    // 在进入的时候 聚焦输入框
    mounted() {
      this.$refs.text.focus()
    },
    computed:{
      ...mapState({
        userID:state=>state.conversation.currentUserID,
        conversationID:state=>state.conversation.conversationID,
        conversation:state=>state.conversation.currentConversation,
        status:state=>state.conversation.conversationStatus,
      }),
      ...mapGetters({
        isShow: 'tool_show',
        messages: 'chat_messages',
      })
    },
    watch: {
      // 在选择其它对话的时候 聚焦输入框
      chatID() {
        setTimeout(() => {
          this.$refs.text.focus()
        }, 0)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tool {
    height: 180px;
    margin-right: 19px;
    border-top: 1px solid #d6d6d6;
    .toolbar {
      height: 40px;
      padding: 5px 15px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      box-sizing: border-box;
      .emoji {
        position: relative;
        height: 40px;
        line-height: 40px;
        padding: 5px;
        box-sizing: border-box;
        .emoji_icon {
          width: 30px;
          height: 30px;
          background: url(./emoji_icon.png) no-repeat center/30px 30px;
          cursor: pointer;
          display: inline-block;
        }
        .emojiBox {
          position: absolute;
          display: flex;
          flex-wrap: wrap;
          top: -210px;
          left: -100px;
          width: 300px;
          height: 200px;
          padding: 5px;
          background-color: #fff;
          border: 1px solid #d1d1d1;
          border-radius: 2px;
          box-shadow:0 1px 2px 1px #d1d1d1;
          li {
            width: 24px;
            height: 24px;
            div {
              cursor: pointer;
            }
          }
          &.showbox-enter-active, &.showbox-leave-active {
            transition: all .5s;
          }
          &.showbox-enter,&.showbox-leave-active {
            opacity: 0;
          }
        }
      }
      .file_upload {
        width: 30px;
        height: 30px;
        margin: 0 5px;
        .upload_icon {
          width: 30px;
          height: 30px;
          background: url(./upload_icon.png) no-repeat center/30px 30px;
          cursor: pointer;
        }
        input {
          flex: 1;
          height: 30px;
          display:none;
        }
      }
    }
    .editArea {
      height: 84px;
      textarea {
        padding: 0 0 0 20px;
        overflow-y: auto;
        overflow-x: hidden;
        font-size: 14px;
        height: 84px;
        width: 100%;
        margin: 0;
        border: 0;
        outline: none;
        resize: none;
        background-color: transparent;
      }
    }
    .action {
      margin-top: 5px;
      text-align: right;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/chat/components/tool.vue